import { render, staticRenderFns } from "./operatingButton.vue?vue&type=template&id=9a3b78b6&scoped=true&"
import script from "./operatingButton.vue?vue&type=script&lang=js&"
export * from "./operatingButton.vue?vue&type=script&lang=js&"
import style0 from "./operatingButton.vue?vue&type=style&index=0&id=9a3b78b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3b78b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a3b78b6')) {
      api.createRecord('9a3b78b6', component.options)
    } else {
      api.reload('9a3b78b6', component.options)
    }
    module.hot.accept("./operatingButton.vue?vue&type=template&id=9a3b78b6&scoped=true&", function () {
      api.rerender('9a3b78b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/operatingButton.vue"
export default component.exports